export const clientSideBrowserCookieIdExperiments: Record<string, never> = {};

export const serverSideBrowserCookieIdExperiments = {
  'car-merch-spinner-raycasting': {},
  'car-merch-ui-quali-factory-upgrades': {},
  'car-merch-ui-vault-spinner': {},
  'car-merch-ui-vdp-vault-why-buys-hotswap': {},
  'car-merch-ui-vdp-zipcode-hero': {},
  'car-merch-vdp-server-availability': {}
};

export const clientSideUserIdExperiments = {};

// NOTE: Not currently wired up in the getExperiments middleware
export const serverSideUserIdExperiments = {};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
